var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'ThemeGroupbuyingList'
      }
    }
  }, [_vm._v("主題團購管理")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("查看主題團購")])], 1)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row mb-2 align-items-center"
  }, [_c('div', {
    staticClass: "col-12 d-flex"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v("查看主題團購")]), _c('div', {
    staticClass: "ml-2"
  }, [_vm.canEdit() ? _c('b-button', {
    attrs: {
      "variant": "inverse-warning",
      "to": {
        name: 'ThemeGroupbuyingEdit',
        params: {
          themeGroupbuyingId: _vm.$route.params.themeGroupbuyingId
        }
      }
    }
  }, [_vm._v(" 編輯團購 ")]) : _vm._e(), _vm.canDelete() ? _c('b-button', {
    staticClass: "ml-1",
    attrs: {
      "variant": "inverse-danger"
    },
    on: {
      "click": function click($event) {
        return _vm.showDeleteThemeWindow();
      }
    }
  }, [_vm._v(" 刪除團購 ")]) : _vm._e()], 1)])]), _vm.isFetched ? _c('theme-groupbuying-form', {
    ref: "form",
    attrs: {
      "form": _vm.form,
      "start-at": _vm.startAt,
      "end-at": _vm.endAt
    }
  }) : _vm._e(), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'ThemeGroupbuyingList'
        });
      }
    }
  }, [_vm._v("返回")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }